/**
 * Public, read-only demo of the admin dashboard, served at
 * `/demo/enrichment` on the marketing site. In demo mode the Supabase client
 * is replaced by an in-memory one (see demoSupabase.ts), so the page never
 * contacts the database and cannot write to it.
 */
export const DEMO_BASE_PATH = "/demo/enrichment";

export const DEMO_USER_ID = "d3ad0000-0000-4000-8000-000000000001";
export const DEMO_BUSINESS_ID = "d3ad0000-0000-4000-8000-0000000000b1";
export const DEMO_OUTLET_ID = "d3ad0000-0000-4000-8000-0000000000a1";
export const DEMO_BUSINESS_NAME = "Resonance Music Studio";

export const isDemoMode = (
  pathname: string = typeof window !== "undefined" ? window.location.pathname : "",
): boolean => pathname === DEMO_BASE_PATH || pathname.startsWith(`${DEMO_BASE_PATH}/`);
